import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {DeleteLinkviewCommand, DeleteLinkviewPayload} from "../commands/delete-linkview.command";

/**
 * Serialises a DeleteLinkviewCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — these commands carry a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, which wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * The full envelope is emitted, not just the payload: inside a bulk each
 * sub-command is re-built through the command factory on the server, so every
 * element needs `name`, `uid`, `mainEntityClass` and `mainEntityUid` exactly
 * like an outer command.
 *
 * The payload is `{uid}` and goes out untouched.
 */
@injectable()
@transformer({
    source: DeleteLinkviewCommand,
    target: `dto`
})
export class DeleteLinkviewCommandToDtoTransformer implements TransformerInterface<CommandDTO<DeleteLinkviewPayload>, DeleteLinkviewCommand> {

    public async transform(command: DeleteLinkviewCommand): Promise<CommandDTO<DeleteLinkviewPayload>> {
        return <CommandDTO<DeleteLinkviewPayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
